import { useEffect, useRef, useState } from 'react';
import usePrevious from '../../../hooks/use-previous';
import SidePanel from '../../side-panel/side-panel';
import { SidePanelType } from '../../side-panel/types';
import ButtonPseudo from '../../button/button-pseudo';
import ExchangeContent from './exchange-content';
import {
  BaseellaStatus,
  DocumentStatus,
  CustomerType,
  EnumExchangeTabs,
} from '../types';
import SidePanelLoader from '../../side-panel/loader';
import ButtonPrimary from '../../button/button-primary';
import ExchangeContentRead from './exchange-transaction-sidepanel-read';
import Popup from '../../popup/popup';
import SignaturePopup from '../signature-popup';
import PermissionDenied from '../../permission-denied/permission-denied';
import DocumentSidePanel from '../documents/document-sidepanel';
import ButtonSecondary from '../../button/button-secondary';
import { PermissionEnum } from '../../../base-types';
import GeneralLedgerSidepanel from '../general-ledger/general-ledger-sidepanel';
import { ExchangeSidePanelTypes } from './types';

import styles from '../transaction.module.css';

export default function ExchangeSidepanel({
  panelIsOpen,
  handleClose,
  control,
  isLoading,
  enableEdit,
  statusesInfo,
  onRollbackStatus,
  onNextStatus,
  transactionInfo,
  recipientAccounts,
  senderAccounts,
  currencies,
  isEditable,
  logs,
  handleSubmit,
  isCreateForm,
  rateSources,
  title,
  isDisabledSaveButton,
  children,
  errors,
  senderAccountsIsLoading,
  recipientAccountsIsLoading,
  currencyFromId,
  currencyToId,
  fromAccountBalance,
  balanceFromAccountIsLoading,
  toAccountBalance,
  balanceToAccountIsLoading,
  exchangeType,
  setValue,
  senderAccountNumber,
  calculateResult,
  baseellaStatus,
  changeLogs,
  tabs,
  exchangeCurrencyFixedId,
  calculateInProgress,
  isDirty,
  calcError,
  accountCategories,
  accountsCategoriesLoading,
  onSearchAutocomplete,
  setSenderAccounts,
  setSenderAccountQuery,
  setRecipientAccounts,
  setRecipientAccountQuery,
  onChangeStatusPopup,
  statusPopupVisible,
  setStatusPopupVisible,
  validateCode,
  signaturePopupVisible,
  sendCode,
  validateCodeInProgress,
  transactionId,
  signatures,
  errorSidepanel,
  rejectPopupVisible,
  setRejectPopupVisible,
  onReject,
  rejectInProgress,
  errorMessageSignature,
  createAllowed,
  updateStatusIsLoading,
  isLoadingStatuses,
  onSignatureCancelClick,
  latestQueuedStatus,
  statusChangeError,
  createdByOrganizationId,
  onChangeStatusPopupLoading,
  chats,
  companyOfficials,
  onCreateTransactionChat,
  chatCreateInProgress,
  currentEmployee,
  documents,
  document: documentItem,
  documentFileIsLoading,
  downloadInProgress,
  imgLink,
  onDelete,
  deleteInProgress,
  onMove,
  moveInProgress,
  onDownload,
  deleteIsVisible,
  sendComment,
  editComment,
  editCommentInProgress,
  editCommentIsSuccess,
  deleteComment,
  deleteCommentInProgress,
  commentInProgress,
  statusChangeInProgress,
  changeCustomerDocumentsStatus,
  onUploadDocument,
  uploadDocumentInProgress,
  uploadDocumentIsSuccess,
  uploadDocumentErrors,
  activePermission,
  onDownloadSuccess,
  glTransactionsIsLoading,
  glTransactions,
  onGlTransactionClick,
  glTransactionIsLoading,
  glTransaction,
  clearGlTransactionState,
  getTransactionDocument,
  documentIsLoading,
  deleteIsSuccess,
  expandedGLTransactionCreditBalance,
  expandedGLTransactionDebitBalance,
  expendedDebitBalanceIsLoading,
  expendedCreditBalanceIsLoading,
  deleteTransactionError,
  onDeleteTransactions,
  deleteTransactionInProgress,
  deleteTransactionDisabled,
  createInProgress,
  editInProgress,
  internalError,
  canSignTransaction,
  onUpdateRates,
  providersRate,
  sendCodeInProgress,
  fromAccountBalances,
  toAccountBalances,
  currenciesList,
  onDuplicate,
  duplicate,
  calculateTransactionRatesByIdAction,
  fields,
  caspEnabled,
  transactionChatsIsLoading,
  isLoadingSignatures,
  isLoadingLogs,
  getLogsTransactionById,
  getGeneralLedgerTransactionValues,
  getTransactionsChats,
  getCompanyOfficials,
  getSignaturesTransactionById,
  overdraftEnabled,
  baseRateSource,
  calculateOnSwap,
  getTransactionChangeLogs,
  changeLogsIsLoading,
  users,
  transactionChangeLogsPagination,
  changeLogsIsFetching,
  setInverseRateChanged,
  sidepanelExpandedKey,
  exchangeDateOfRate,
  transactionComments,
  transactionCommentsPagination,
  getTransactionCommentsAction,
  commentsIsLoading,
  commentsIsFetching,
  onAddCommentToTransaction,
  addCommentInProgress,
  addCommentIsSuccess,
  onEditCommentInTransaction,
  editTransactionCommentInProgress,
  editTrancastionCommentIsSuccess,
  onDeleteCommentInTransaction,
  deleteCommentInTransactionInProgress,
  deleteCommentInTranscationIsSuccess,
  syncedTransactionsIds,
  getSyncedTransactions,
  syncedTransactionsIsLoading,
  syncedTransactionsIsFetching,
  syncedTransactions,
  getIntegrationLogs,
  integrationLogsIsLoading,
  integrationLogsIsFetching,
  integrationLogs,
  integrationLogsPagination,
  withoutCorrections,
  onAddMissing,
  addMissingInProgress,
  deleteDisabled,
  setError,
  clearErrors,
}: ExchangeSidePanelTypes): React.JSX.Element {
  const [transactionSidePanelVisible, setTransactionSidepanelVisible] =
    useState(panelIsOpen);
  const [dirtyPopupVisible, setDirtyPopupVisible] = useState(false);
  const [scroll, setScroll] = useState(0);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [deletePopupVisible, setDeletePopupVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<
    DocumentStatus | undefined
  >(undefined);
  const [selectedDocumentName, setSelectedDocumentName] = useState('');
  const [subPanelVisible, setSubPanelVisible] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState('');
  const [activeTab, setActiveTab] = useState<EnumExchangeTabs>(
    EnumExchangeTabs.GENERAL,
  );
  const [glTransactionSidepanelVisible, setGlTransactionSidePanelVisible] =
    useState(false);
  const [deleteTransactionPopupVisible, setDeleteTransactionPopupVisible] =
    useState(false);
  const [confirmationPopupVisible, setConfirmationPopupVisible] =
    useState(false);

  const prevEditInProgress = usePrevious(editInProgress);

  const tabsItems = [
    { name: 'Details', value: EnumExchangeTabs.GENERAL },
    { name: 'Status log', value: EnumExchangeTabs.LOG },
    { name: 'Change log', value: EnumExchangeTabs.CHANGE_LOG },
    { name: 'Signatures', value: EnumExchangeTabs.SIGNATURES },
    { name: 'Documents', value: EnumExchangeTabs.DOCUMENTS },
    { name: 'Accounting entries', value: EnumExchangeTabs.GL_TRANSACTIONS },
    {
      name: 'Linked Transactions',
      value: EnumExchangeTabs.SYNCED_TRANSACTIONS,
    },
    { name: 'Chats', value: EnumExchangeTabs.CHATS },
    { name: 'Comments', value: EnumExchangeTabs.COMMENTS },
    { name: 'Integration Logs', value: EnumExchangeTabs.INTEGRATION_LOGS },
  ];

  const handleScroll = () => {
    setScroll((prev) => {
      if (prev !== Number(scrollRef.current?.scrollTop)) {
        return Number(scrollRef.current?.scrollTop);
      }
      return prev;
    });
  };

  useEffect(() => {
    const element = scrollRef.current;

    element?.addEventListener('scroll', handleScroll);

    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    setTransactionSidepanelVisible(panelIsOpen);
  }, [panelIsOpen]);

  useEffect(() => {
    if (onDownloadSuccess && selectedDocumentId && !downloadInProgress) {
      setSelectedDocumentId('');
    }
  }, [onDownloadSuccess, selectedDocumentId, downloadInProgress]);

  useEffect(() => {
    if (deleteIsSuccess) {
      setDeletePopupVisible(false);
      setSubPanelVisible(false);
      setTransactionSidepanelVisible(true);
      setActiveTab(EnumExchangeTabs.DOCUMENTS);
    }
  }, [deleteIsSuccess]);

  useEffect(() => {
    if (duplicate) {
      setActiveTab(EnumExchangeTabs.GENERAL);
    }
  }, [duplicate]);

  useEffect(() => {
    if (!editInProgress && prevEditInProgress) {
      setConfirmationPopupVisible(false);
    }
  }, [editInProgress, prevEditInProgress]);

  let content;
  let contentError;

  if (isLoading && !internalError) {
    content = <SidePanelLoader />;
  } else if (enableEdit && !internalError) {
    if ((isCreateForm && createAllowed) || transactionId) {
      content = (
        <ExchangeContent
          control={control}
          transactionInfo={transactionInfo}
          recipientAccounts={recipientAccounts}
          senderAccounts={senderAccounts}
          currencies={currencies}
          isEditable={isEditable}
          onSearchAutocomplete={onSearchAutocomplete}
          logs={logs}
          isCreateForm={isCreateForm}
          rateSources={rateSources}
          statusesInfo={statusesInfo}
          onRollbackStatus={onRollbackStatus}
          onNextStatus={onNextStatus}
          recipientAccountsIsLoading={recipientAccountsIsLoading}
          senderAccountsIsLoading={senderAccountsIsLoading}
          currencyFromId={currencyFromId}
          currencyToId={currencyToId}
          fromAccountBalance={fromAccountBalance}
          balanceFromAccountIsLoading={balanceFromAccountIsLoading}
          toAccountBalance={toAccountBalance}
          balanceToAccountIsLoading={balanceToAccountIsLoading}
          errors={errors}
          exchangeType={exchangeType}
          setValue={setValue}
          senderAccountNumber={senderAccountNumber}
          calculateResult={calculateResult}
          baseellaStatus={baseellaStatus}
          changeLogs={changeLogs}
          exchangeCurrencyFixedId={exchangeCurrencyFixedId}
          isLoading={isLoading}
          accountCategories={accountCategories}
          accountsCategoriesLoading={accountsCategoriesLoading}
          setSenderAccounts={setSenderAccounts}
          setSenderAccountQuery={setSenderAccountQuery}
          setRecipientAccounts={setRecipientAccounts}
          setRecipientAccountQuery={setRecipientAccountQuery}
          signatures={signatures}
          sendCode={sendCode}
          setRejectPopupVisible={setRejectPopupVisible}
          parentRef={scrollRef}
          parentScroll={scroll}
          updateStatusIsLoading={updateStatusIsLoading}
          isLoadingStatuses={isLoadingStatuses}
          latestQueuedStatus={latestQueuedStatus}
          createdByOrganizationId={createdByOrganizationId}
          companyOfficials={companyOfficials}
          chats={chats}
          onCreateTransactionChat={onCreateTransactionChat}
          chatCreateInProgress={chatCreateInProgress}
          currentEmployee={currentEmployee}
          documents={documents}
          setSubPanelVisible={setSubPanelVisible}
          uploadDocumentInProgress={uploadDocumentInProgress}
          uploadDocumentIsSuccess={uploadDocumentIsSuccess}
          setSelectedDocumentName={setSelectedDocumentName}
          setTransactionSidepanelVisible={setTransactionSidepanelVisible}
          onUploadDocument={onUploadDocument}
          uploadDocumentErrors={uploadDocumentErrors}
          selectedDocumentId={selectedDocumentId}
          setSelectedDocumentId={setSelectedDocumentId}
          downloadInProgress={documentFileIsLoading || downloadInProgress}
          tabs={tabsItems}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          glTransactionsIsLoading={glTransactionsIsLoading}
          glTransactions={glTransactions}
          setGlTransactionSidePanelVisible={setGlTransactionSidePanelVisible}
          onGlTransactionClick={onGlTransactionClick}
          onDownloadDocument={onDownload}
          getTransactionDocument={getTransactionDocument}
          activePermission={activePermission}
          canSignTransaction={canSignTransaction}
          onUpdateRates={onUpdateRates}
          calculateInProgress={calculateInProgress}
          providersRate={providersRate}
          calcError={calcError}
          sendCodeInProgress={sendCodeInProgress}
          fromAccountBalances={fromAccountBalances}
          toAccountBalances={toAccountBalances}
          currenciesList={currenciesList}
          transactionId={transactionId}
          fields={fields}
          calculateTransactionRatesByIdAction={
            calculateTransactionRatesByIdAction
          }
          caspEnabled={caspEnabled}
          transactionChatsIsLoading={transactionChatsIsLoading}
          isLoadingSignatures={isLoadingSignatures}
          isLoadingLogs={isLoadingLogs}
          getLogsTransactionById={getLogsTransactionById}
          getGeneralLedgerTransactionValues={getGeneralLedgerTransactionValues}
          getTransactionsChats={getTransactionsChats}
          getCompanyOfficials={getCompanyOfficials}
          getSignaturesTransactionById={getSignaturesTransactionById}
          overdraftEnabled={overdraftEnabled}
          baseRateSource={baseRateSource}
          calculateOnSwap={calculateOnSwap}
          getTransactionChangeLogs={getTransactionChangeLogs}
          changeLogsIsLoading={changeLogsIsLoading}
          users={users}
          transactionChangeLogsPagination={transactionChangeLogsPagination}
          changeLogsIsFetching={changeLogsIsFetching}
          setInverseRateChanged={setInverseRateChanged}
          exchangeDateOfRate={exchangeDateOfRate}
          transactionComments={transactionComments}
          transactionCommentsPagination={transactionCommentsPagination}
          getTransactionCommentsAction={getTransactionCommentsAction}
          commentsIsLoading={commentsIsLoading}
          commentsIsFetching={commentsIsFetching}
          onAddCommentToTransaction={onAddCommentToTransaction}
          addCommentInProgress={addCommentInProgress}
          addCommentIsSuccess={addCommentIsSuccess}
          onEditCommentInTransaction={onEditCommentInTransaction}
          editTransactionCommentInProgress={editTransactionCommentInProgress}
          editTrancastionCommentIsSuccess={editTrancastionCommentIsSuccess}
          onDeleteCommentInTransaction={onDeleteCommentInTransaction}
          deleteCommentInTransactionInProgress={
            deleteCommentInTransactionInProgress
          }
          deleteCommentInTranscationIsSuccess={
            deleteCommentInTranscationIsSuccess
          }
          syncedTransactionsIds={syncedTransactionsIds}
          getSyncedTransactions={getSyncedTransactions}
          syncedTransactionsIsLoading={syncedTransactionsIsLoading}
          syncedTransactionsIsFetching={syncedTransactionsIsFetching}
          syncedTransactions={syncedTransactions}
          getIntegrationLogs={getIntegrationLogs}
          integrationLogsIsLoading={integrationLogsIsLoading}
          integrationLogsIsFetching={integrationLogsIsFetching}
          integrationLogs={integrationLogs}
          integrationLogsPagination={integrationLogsPagination}
          setError={setError}
          clearErrors={clearErrors}
        />
      );
    } else if (!createAllowed && isCreateForm) {
      content = <PermissionDenied />;
    }
  } else if (internalError) {
    content = <div className={styles.internalError}>{internalError}</div>;
  } else {
    content = (
      <ExchangeContentRead
        tabs={tabs}
        parentRef={scrollRef}
        parentScroll={scroll}
        deletedAt={transactionInfo?.deletedAt}
      />
    );
  }

  if (errors) {
    contentError = 'There are errors in some fields';
  } else if (calcError) {
    contentError = calcError;
  } else if (errorSidepanel) {
    contentError = errorSidepanel;
  }

  let footerButton;

  if (baseellaStatus !== BaseellaStatus.NOT_SIGNED && enableEdit) {
    if (transactionId && isEditable) {
      footerButton = (
        <ButtonPrimary
          text="Save"
          disabled={isDisabledSaveButton}
          onClick={() => setConfirmationPopupVisible(true)}
          bold
        />
      );
    } else if (isCreateForm && createAllowed) {
      footerButton = (
        <ButtonPrimary
          text={createInProgress ? 'Loading...' : 'Save'}
          disabled={isDisabledSaveButton}
          onClick={sendCode}
          bold
        />
      );
    }
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={transactionSidePanelVisible}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title={title}
        footerVisible={enableEdit}
        errorSidepanel={contentError || statusChangeError}
        className={styles.transactionSidepanel}
        childrenRef={scrollRef}
        checkInProgress={calculateInProgress}
        checkText=" Calculating rates..."
        sidepanelExpandedKey={sidepanelExpandedKey}
        footer={
          <>
            {!internalError && footerButton}
            {!isLoading && (
              <>
                {transactionId && onDuplicate && !withoutCorrections && (
                  <ButtonSecondary
                    text="Duplicate"
                    onClick={onDuplicate}
                    className={styles.duplicateButton}
                    disabled={Boolean(
                      updateStatusIsLoading ||
                      statusChangeInProgress ||
                      deleteTransactionInProgress ||
                      editInProgress,
                    )}
                    bold
                  />
                )}
                {transactionId && withoutCorrections && onAddMissing && (
                  <ButtonSecondary
                    text={addMissingInProgress ? 'Loading...' : 'Add missing'}
                    onClick={onAddMissing}
                    className={`${styles.duplicateButton} ${styles.addMissing}`}
                    disabled={Boolean(
                      updateStatusIsLoading ||
                      statusChangeInProgress ||
                      deleteTransactionInProgress ||
                      editInProgress,
                    )}
                    bold
                  />
                )}
                {!internalError && transactionId && !deleteDisabled && (
                  <ButtonSecondary
                    text={
                      deleteTransactionInProgress
                        ? 'Loading...'
                        : 'Delete transaction'
                    }
                    className={`button-white button-warning ${styles.deleteTransactionButton}`}
                    disabled={
                      deleteTransactionInProgress ||
                      deleteTransactionDisabled ||
                      updateStatusIsLoading ||
                      statusChangeInProgress ||
                      deleteTransactionInProgress ||
                      editInProgress
                    }
                    onClick={() => setDeleteTransactionPopupVisible(true)}
                    bold
                  />
                )}
              </>
            )}

            <ButtonPseudo text="Cancel" onClick={handleClose} bold />
          </>
        }
      >
        <>
          {children}
          {content}
        </>
      </SidePanel>
      <GeneralLedgerSidepanel
        panelIsOpen={glTransactionSidepanelVisible}
        handleClose={() => {
          if (clearGlTransactionState) {
            clearGlTransactionState();
          }
          setTransactionSidepanelVisible(true);

          setGlTransactionSidePanelVisible(false);
          setActiveTab(EnumExchangeTabs.GL_TRANSACTIONS);
        }}
        transaction={glTransaction}
        isLoading={glTransactionIsLoading as boolean}
        title="GL Transaction"
        debitAccountBalance={expandedGLTransactionDebitBalance}
        creditAccountBalance={expandedGLTransactionCreditBalance}
        debitBalanceIsLoading={expendedDebitBalanceIsLoading}
        creditBalanceIsLoading={expendedCreditBalanceIsLoading}
        sidepanelExpandedKey="exchange-gl-transaction"
      />
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={subPanelVisible}
        onClose={() => {
          setSubPanelVisible(false);
          setSelectedDocumentName('');
          setTransactionSidepanelVisible(true);
          setActiveTab(EnumExchangeTabs.DOCUMENTS);
        }}
        title={selectedDocumentName}
        className={styles.subPanel}
        sidepanelExpandedKey="exchange-document"
        footer={
          <>
            {((transactionInfo?.recipientAccount?.organization?.type ===
              CustomerType.INDIVIDUAL &&
              activePermission?.includes(
                PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
              )) ||
              (transactionInfo?.recipientAccount?.organization?.type ===
                CustomerType.CORPORATE &&
                activePermission?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
                ))) &&
              documentItem && (
                <>
                  {documentItem.status !== DocumentStatus.ACCEPTED &&
                    documentItem.status !== DocumentStatus.EXPIRED && (
                      <ButtonSecondary
                        text={
                          statusChangeInProgress &&
                          selectedStatus === DocumentStatus.ACCEPTED
                            ? 'Loading...'
                            : 'Accept'
                        }
                        onClick={() => {
                          setSelectedStatus(DocumentStatus.ACCEPTED);

                          if (changeCustomerDocumentsStatus) {
                            changeCustomerDocumentsStatus({
                              ids: [documentItem?.id],
                              status: DocumentStatus.ACCEPTED,
                            });
                          }
                        }}
                        disabled={statusChangeInProgress || documentIsLoading}
                        bold
                      />
                    )}
                  {documentItem.status !== DocumentStatus.REJECTED &&
                    documentItem.status !== DocumentStatus.EXPIRED && (
                      <ButtonSecondary
                        text={
                          statusChangeInProgress &&
                          selectedStatus === DocumentStatus.REJECTED
                            ? 'Loading...'
                            : 'Reject'
                        }
                        className={styles.rejectStatusButton}
                        onClick={() => {
                          setSelectedStatus(DocumentStatus.REJECTED);

                          if (changeCustomerDocumentsStatus) {
                            changeCustomerDocumentsStatus({
                              ids: [documentItem?.id],
                              status: DocumentStatus.REJECTED,
                            });
                          }
                        }}
                        disabled={statusChangeInProgress || documentIsLoading}
                        bold
                      />
                    )}
                </>
              )}
            <ButtonPseudo
              text="Close"
              onClick={() => {
                setSubPanelVisible(false);
                setSelectedDocumentName('');
                setTransactionSidepanelVisible(true);
                setActiveTab(EnumExchangeTabs.DOCUMENTS);
              }}
              className="button-white"
              bold
            />
          </>
        }
      >
        {documentIsLoading ? (
          <SidePanelLoader />
        ) : (
          <DocumentSidePanel
            document={documentItem}
            documentFileIsLoading={documentFileIsLoading}
            downloadInProgress={downloadInProgress}
            imgLink={imgLink}
            setDeletePopupVisible={setDeletePopupVisible}
            onMove={onMove}
            moveInProgress={moveInProgress}
            onDownload={onDownload}
            deleteIsVisible={deleteIsVisible}
            customerType={transactionInfo?.recipientAccount?.organization?.type}
            commentsVisible={activePermission?.includes(
              PermissionEnum.DOCUMENTS_COMMENTS_ACTION,
            )}
            sendComment={sendComment}
            editComment={editComment}
            editCommentInProgress={editCommentInProgress}
            editCommentIsSuccess={editCommentIsSuccess}
            deleteComment={deleteComment}
            deleteCommentInProgress={deleteCommentInProgress}
            commentInProgress={commentInProgress}
            activePermissions={activePermission}
            onDownloadSuccess={onDownloadSuccess}
          />
        )}
      </SidePanel>
      <Popup
        title="Delete transaction?"
        onCancelClick={() => setDeleteTransactionPopupVisible(false)}
        onOkClick={() =>
          onDeleteTransactions && onDeleteTransactions(transactionId as string)
        }
        cancelButtonText="Cancel"
        okButtonText={deleteTransactionInProgress ? 'Loading...' : 'Delete'}
        isVisible={deleteTransactionPopupVisible}
        isLoading={deleteTransactionInProgress}
        parent={document.getElementById('delete-popup-wrapper') as HTMLElement}
      >
        <div>
          {deleteTransactionError && (
            <div className={styles.transactionDeleteError}>
              {deleteTransactionError}
            </div>
          )}
        </div>
      </Popup>
      <Popup
        title={`Delete ${documentItem?.name}`}
        onCancelClick={() => setDeletePopupVisible(false)}
        onOkClick={() => onDelete && onDelete(documentItem?.id as string)}
        cancelButtonText="Cancel"
        okButtonText={deleteInProgress ? 'Loading...' : 'Delete'}
        isVisible={deletePopupVisible}
        isLoading={deleteInProgress}
        parent={document.getElementById('delete-popup-wrapper') as HTMLElement}
      />
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <Popup
        title="You have unsaved changed"
        description="You want to change the status of a transaction, but you have unsaved changes on the transaction. Please select one of the following options:"
        onCancelClick={() =>
          setStatusPopupVisible && setStatusPopupVisible(false)
        }
        onOkClick={onChangeStatusPopup}
        isLoading={onChangeStatusPopupLoading}
        cancelButtonText="Cancel"
        okButtonText="Save changes and change status"
        isVisible={Boolean(statusPopupVisible)}
        parent={document.getElementById('status-popup') as HTMLElement}
        okButtonDisabled={isDisabledSaveButton}
      />
      <Popup
        title="The transaction will be rejected"
        onCancelClick={() =>
          setRejectPopupVisible && setRejectPopupVisible(false)
        }
        onOkClick={onReject}
        cancelButtonText="Cancel"
        okButtonText="Yes, Reject"
        isVisible={rejectPopupVisible as boolean}
        parent={document.getElementById('signature-popup') as HTMLElement}
        isLoading={rejectInProgress}
      />
      <SignaturePopup
        signaturePopupVisible={signaturePopupVisible}
        validateCode={validateCode}
        validateCodeInProgress={validateCodeInProgress}
        errorMessageSignature={errorMessageSignature}
        onSignatureCancelClick={onSignatureCancelClick}
      />
      <Popup
        title="Are you sure to save all changes?"
        onCancelClick={() => setConfirmationPopupVisible(false)}
        onOkClick={handleSubmit}
        isLoading={editInProgress}
        cancelButtonText="Cancel"
        okButtonText={editInProgress ? 'Loading...' : 'Save changes'}
        isVisible={confirmationPopupVisible}
        parent={document.getElementById('status-popup') as HTMLElement}
        okButtonDisabled={editInProgress}
      />
      <div id="status-popup" />
      <div id="dirty-popup" />
      <div id="signature-popup" />
      <div id="delete-popup-wrapper" />
    </>
  );
}
